import React from 'react';
import { DemeterTableDefinitionType } from '../../../Generated/Raven-Demeter/api';
import { TrackingEvent } from '../../Services/Tracking/TrackingService';
import MenuByRegionCommodity from '../MenuFileSelectors/MenuByRegionCommodity';
import PageHeader from './PageHeader';

export interface IPageHeaderWithSelectionsProps {
    title: string;
    tableDefinitionType: DemeterTableDefinitionType;
    showMainRegionsAndGroupsOnly?: boolean;
    rightSideOfHeaderComponent?: JSX.Element;
    rightSideOfBreadcrumbsComponent?: JSX.Element;
    testId?: string;
    track: TrackingEvent;
}

const PageHeaderWithSelections: React.FC<IPageHeaderWithSelectionsProps> = (props: IPageHeaderWithSelectionsProps) => (
    <PageHeader title={props.title} rightSideComponent={props.rightSideOfHeaderComponent} testId={props.testId}>
        {props.tableDefinitionType && (
            <MenuByRegionCommodity
                showMainRegionsAndCommoditiesGroupsOnly={props.showMainRegionsAndGroupsOnly}
                tableDefinitionType={props.tableDefinitionType}
                rightSideOfBreadcrumbsComponent={props.rightSideOfBreadcrumbsComponent}
                track={{ eventCategory: props.track.eventCategory, eventAction: 'MenuByRegionCommodity' }}
            />
        )}
    </PageHeader>
);

export default PageHeaderWithSelections;
